import Navigation from './Navigation';
import PrimaryHeader from './PrimaryHeader';

import type { Stay } from '@shared/types/utils';
import type { Destination } from '@shared/ui/types';
import type { NavigationItems } from '@shared/utils-frontend/navigation-service';

type Props = {
  backHref: string;
  items: NavigationItems;
  destination: Destination;
  stay: Stay;
};

const Header = ({ backHref, destination, stay, ...rest }: Props) => (
  <>
    <PrimaryHeader backHref={backHref} id={destination.entityId} />
    <Navigation
      destination={destination}
      primaryHeaderHeight={56}
      stay={stay}
      {...rest}
    />
  </>
);

export default Header;
